import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export const FromWaldrechner = () => {
  const { t } = useTranslation();

  return (
    <section 
      id="from-waldrechner" 
      className="py-10 bg-emerald-50 border-y border-emerald-100"
      data-testid="from-waldrechner-section"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 
          className="text-lg md:text-xl font-semibold text-[#1B4D3E] mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('fromWaldrechner.headline')}
        </h2>
        <p className="text-stone-600 text-sm md:text-base leading-relaxed">
          {t('fromWaldrechner.text')}
        </p>
      </div>
    </section>
  );
};
